import {Component, EventEmitter, Output} from '@angular/core';
import {of, Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, map, mergeMap} from 'rxjs/operators';
import {UserContextService} from '../../../../../application/app-context/user-context/user-context.service';
import {AccountService} from '../../../../../domain/core/service/account.service';
import {Account} from '../../../../../domain/core/model/account';
import {DomainUrlService} from '../../../../../application/config/domain-url.service';
import {SafeSubscriberDirective} from '../../../../../application/app-context/safe-subscriber.directive';

@Component({
  selector: 'app-home-menu-switch-account',
  templateUrl: './home-menu-switch-account.component.html',
  styleUrls: ['./home-menu-switch-account.component.scss']
})
export class HomeMenuSwitchAccountComponent extends SafeSubscriberDirective {


  @Output() switchAccount: EventEmitter<void> = new EventEmitter<void>();

  public keyUp = new Subject<any>();
  showSpinnerResearch = false;
  filteredAccounts: Array<Account>;

  constructor(private contextService: UserContextService,
              private accountService: AccountService,
              private domainUrlService: DomainUrlService) {
    super();
    this.filteredAccounts = [];
    this.subs.push(this.keyUp.pipe(
      map(event => event.target.value),
      debounceTime(800),
      distinctUntilChanged(),
      mergeMap(search => {
        this.showSpinnerResearch = true;
        return search ? this.accountService.search(search) : of(this.accountsForEmptySearch());
      }))
                       .subscribe(accounts => {
                         this.showSpinnerResearch = false;
                         this.filteredAccounts = accounts;
                       }, error => console.error('Error while performing search...\n' + error)));
  }

  onAccountSelected(account: Account): void {
    window.location.href = `${this.domainUrlService.getDashboardUrl()}?accountId=${account.accountId}`;
  }

  private accountsForEmptySearch(): Array<Account> {
    const userContext = this.contextService.getUserContext();
    return userContext.user.accounts;
  }
}
